/* @flow */

import React from 'react';
import Date from './Date';

type Props = {
  value: object,
  showTimeSelect?: boolean,
  onChange: (value: object) => void,
};

const DateRange = ({ value, showTimeSelect, onChange }: Props) => {
  const onStartChange = start =>
    onChange({
      ...value,
      start,
    });

  const onEndChange = end =>
    onChange({
      ...value,
      end,
    });

  return (
    <div className="ui grid">
      <div className="eight wide column">
        <Date
          label="Début"
          name="start"
          value={value.start}
          onChange={onStartChange}
          showTimeSelect={showTimeSelect}
          selectsStart
          startDate={value.start}
          endDate={value.end}
        />
      </div>
      <div className="eight wide column">
        <Date
          label="Fin"
          name="end"
          value={value.end}
          onChange={onEndChange}
          showTimeSelect={showTimeSelect}
          selectsEnd
          startDate={value.start}
          endDate={value.end}
        />
      </div>
    </div>
  );
};

export default DateRange;



// WEBPACK FOOTER //
// ./src/modules/calendar/components/DateRange.js